import { callApi } from './common'

function workerCommand(command, params, target = 'billing') {
  return callApi(`manage/worker/${target}/${command}`, params, 'post')
}

export default {
  workerCommand,
}
